import {get, post, put, _delete} from './Tools';

const getById = async (conceptId) => {
  const response = await get(`${process.env.REACT_APP_SERVER}concepto_acomulado/${conceptId}`);
  return response;
};
const getAll = async () => {
  const response = await get(`${process.env.REACT_APP_SERVER}concepto_acomulado`);
  return response;
};
const getAllByConcept = async (conceptId) => {
  const response = await get(`${process.env.REACT_APP_SERVER}concepto_acomulado/concepto/${conceptId}`);
  return response;
};
const getAllByAcomulado = async (acomuladoId) => {
  const response = await get(`${process.env.REACT_APP_SERVER}concepto_acomulado/acomulado/${acomuladoId}`);
  return response;
};
const insert = async (payload) => {
  const response = await post(`${process.env.REACT_APP_SERVER}concepto_acomulado`, payload);
  return response;
};
const drop = async (id) => {
  const response = await _delete(`${process.env.REACT_APP_SERVER}concepto_acomulado/${id}`);
  return response;
};

export { getAll, getAllByConcept, getAllByAcomulado, getById, insert, drop };
